import { AlertCircle, RotateCcw } from "lucide-react";

export function ErrorPanel({
  title = "We couldn’t load this content",
  text = "Please check your connection and try again.",
  onRetry
}: {
  title?: string;
  text?: string;
  onRetry?: () => void;
}) {
  return (
    <div className="error-panel" role="alert">
      <span className="error-icon" aria-hidden="true"><AlertCircle /></span>
      <div>
        <h3>{title}</h3>
        <p>{text}</p>
      </div>
      {onRetry && (
        <button className="btn btn-outline" type="button" onClick={onRetry}>
          <RotateCcw aria-hidden="true" /> Try again
        </button>
      )}
    </div>
  );
}
